import { useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const errorText = detail => {
  if (!detail) return "Giriş yapılamadı, lütfen tekrar deneyin";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
};

export default function LoginPage() {
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async event => {
    event.preventDefault();
    setBusy(true); setError("");
    try {
      await login(identifier.trim(), password);
    } catch (e) {
      setError(errorText(e?.response?.data?.detail || e.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card" data-testid="login-page">
        <div className="auth-brand">
          <img src="/roimax-logo.png" alt="Roimax" className="auth-logo" data-testid="login-logo"/>
          <span className="brand-sub">finans paneli</span>
        </div>
        <h2>Panele giriş</h2>
        <p className="auth-sub">Kullanıcı adınız veya e-posta adresinizle giriş yapın.</p>
        <form onSubmit={submit}>
          <div className="field">
            <label htmlFor="identifier">Kullanıcı adı veya e-posta</label>
            <input id="identifier" data-testid="login-identifier-input" autoFocus autoComplete="username"
              value={identifier} onChange={e => setIdentifier(e.target.value)} required/>
          </div>
          <div className="field">
            <label htmlFor="password">Şifre</label>
            <input id="password" data-testid="login-password-input" type="password" autoComplete="current-password"
              value={password} onChange={e => setPassword(e.target.value)} required/>
          </div>
          <button className="primary-btn" type="submit" data-testid="login-submit-button" disabled={busy}>
            {busy ? <Loader2 size={16} className="spin"/> : <LogIn size={16}/>} Giriş yap
          </button>
          {error && <div className="notice error" data-testid="login-error">{error}</div>}
        </form>
        <small className="auth-foot">Hesabınız yok mu? Yöneticinizden kullanıcı açmasını isteyin.</small>
      </div>
    </div>
  );
}
